import studies from './studies'
import users from './users'

const admin = {
  users,
  studies,
}

export default admin
